import React from 'react';
import styled from '@emotion/styled';

import Meta from '@src/components/Base/Head/Meta';
import Header from '@src/components/Base/Header/StandardHeader';
import DefaultHead from '@src/components/Base/Head/DefaultHead';
import MobileSearchbar from '@src/components/Base/Header/MobileSearchbar';
import Footer from '@src/components/Base/Footer/Footer';
import withoutAuth from '@src/hocs/withoutAuth';

import { SocialComponent } from '@src/components/User/Signup/SocialComponent';
import { RequiredComponent } from '@src/components/User/Signup/RequiredComponent';
import { OptionsComponent } from '@src/components/User/Signup/OptionsComponent';
import { CheckboxComponent } from '@src/components/User/Signup/CheckboxComponent';
import { ButtonComponent } from '@src/components/User/Signup/ButtonComponent';

import { useForm } from '@src/hooks/useForm';

const text = {
  info: '이미 회원이신가요? ',
  login: '로그인',
};

export default withoutAuth(function signup() {
  const {
    values,
    bottomText,
    handleCheckbox,
    handleSignUpAgreeAll,
    handleSignupChange,
    handleSignupSMSRequest,
    handleSignupVerifyCode,
    handleSignupSubmit,
  } = useForm({
    initValues: {
      email: '',
      password: '',
      passwordConfirm: '',
      phoneNumber: '',
      SMSSent: false,
      phoneStatus: '',
      verifyDisabled: true,
      verificationCode: '',
      verifyStatus: '',
      verified: false,
      occupation: '',
      company: '',
      ageConfirmation: false,
      legelengineTnC: false,
      privacyPolicy: false,
      mktAgreement: false,
      isFormReady: false,
      existEmail: false,
    },
  });

  return (
    <div>
      <DefaultHead />
      <Meta title={`리걸엔진 | 회원가입`} description={`리걸엔진 회원가입`} url={`user/signup`} />
      <Header imgSrc='/logo.svg' />
      <MobileSearchbar />
      <Container>
        <Article>
          <SocialComponent />
          <Form onSubmit={handleSignupSubmit}>
            <RequiredComponent values={values} bottomText={bottomText} handleSignupChange={handleSignupChange} />
            <OptionsComponent
              values={values}
              bottomText={bottomText}
              handleSignupChange={handleSignupChange}
              handleSignupSMSRequest={handleSignupSMSRequest}
              handleSignupVerifyCode={handleSignupVerifyCode}
            />
            <CheckboxComponent
              values={values}
              handleSignUpAgreeAll={handleSignUpAgreeAll}
              handleCheckbox={handleCheckbox}
            />
            <ButtonComponent values={values} />
          </Form>
          <Login>
            {text.info}
            <LoginLink href='login'>
              <LoginSpan>{text.login}</LoginSpan>
            </LoginLink>
          </Login>
        </Article>
      </Container>
      <Footer />
    </div>
  );
});

const Container = styled.main`
  background-color: #e5e5e5;
  margin-top: 65px;
  min-height: calc(100vh - 65px);
  display: flex;
  justify-content: center;
  @media screen and (max-width: 992px) {
    margin-top: 0;
  }
`;

const Article = styled.section`
  margin: 50px 0;
  padding-bottom: 50px;
  width: 840px;
  background-color: #ffffff;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  @media screen and (max-width: 992px) {
    margin-bottom: 0;
    width: 100%;
  }
`;

const Form = styled.form`
  margin: 0 5.5rem;
  @media screen and (max-width: 992px) {
    margin: 0 2rem;
  }
`;

const Login = styled.div`
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  @media only screen and (max-width: 992px) {
    font-size: 16px;
  }
`;

const LoginLink = styled.a`
  text-decoration: none;
`;

const LoginSpan = styled.span`
  text-decoration-line: underline;
  color: #000000;
  font-weight: bold;
  cursor: pointer;
`;
